import React from 'react';
import cn from 'classnames';

import styles from './style.module.scss';
import { getIcon } from '@infologistics/frontend-libraries';

interface IProps {
  onClick: () => void;
  showExit: boolean;
}

export const ButtonFormUrl = ({ onClick, showExit }: IProps) => {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <div className={cn(styles.wrapper, 'fixed')} onClick={onClick}>
      <div>{getIcon(showExit ? 'IconTimes' : 'IconCog', { size: isMobile ? 'lg' : 'base' })}</div>
    </div>
  );
};
